export default [
    ["0","0","0","0","0","0","0","0"],
    ["21.33","7.55","14.35","10.09","9.55","8.92","12.88","15.28"],
    ["23.55","8.01","13.55","11.28","7.89","6.65","11.78","17.22"],
    ["25.77","8.47","12.55","10.77","3.2","4.38","10.68","23.55"],
    ["21.33","8.93","9.88","9.56","5.2","2.11","9.58","33.35"],
    ["20.21","9.39","10.01","8.88","6.55","3.53","8.48","32.66"],
    ["19.43","9.85","10","7.58","5.66","4.22","7.38","35.33"],
    ["17.65","10.31","8.85","6.75","6.24","4.44","6.28","39.01"],
    ["16.87","10.77","7.24","6.52","5.22","3.25","5.18","43.21"],
];


// WEBPACK FOOTER //
// ./src/assets/js/misc.js